<template>
  <div class="modal-card" :class="$style.container">
    <header class="modal-card-head">
      <p v-if="isReclaimProject" class="modal-card-title">
        Decline Project Administration Change Request
      </p>
      <p v-else class="modal-card-title">
        Decline Project Administration Request
      </p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>

    <section class="modal-card-body" :class="$style.body">
      <span v-if="isReclaimProject"
        >Please enter a reason for declining Project Administrator Change
        Request for </span
      ><span v-else
        >Please enter a reason for declining Project Administrator for </span
      ><span :class="$style.boldFont">{{ projectName }}</span
      >. <span> Upon submission, </span
      ><span :class="$style.boldFont">{{ notificationSenderName }}</span
      ><span> will be notified of your reason.</span>
      <br />
      <br />
      <b-field label="Reason">
        <b-input v-model="reason" type="textarea"></b-input>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <button class="button is-primary is-rounded" @click="submitReason()">
        Submit
      </button>
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep as _cloneDeep } from 'lodash';
import { get as _get } from 'lodash';

@Component({
  components: {},
})
export default class ProjectOwnerRejectForm extends Vue {
  @Prop()
  public projectName!: string;
  @Prop()
  public notificationSenderName!: string;
  @Prop()
  public isReclaimProject!: boolean;
  public reason: string = '';

  public submitReason() {
    this.$emit('confirm', this.reason);
    this.$emit('close');
  }
}
</script>

<style lang="scss" module>
.body {
  min-height: 200px;
}

.triggerButton {
  width: 100%;
  justify-content: space-between;
}
.boldFont {
  font-weight: 700;
}
.container {
  :global(.modal-card-body) {
    overflow: visible;
  }

  .triggerButton {
    width: 100%;
    justify-content: space-between;

    span {
      font-weight: normal;
    }
  }
}
</style>
